import * as countryFlags from "country-flag-icons/react/3x2";
import styled from "styled-components";

import type { ComponentType } from "react";

interface IFlagProps {
    code: string
}

// indexed access on the namespace import, which eslint cannot validate statically
const flags: Record<string, ComponentType> = countryFlags;

export default styled.svg.attrs<IFlagProps>(
    (props) => (
        {
            as: flags[props.code],
        }
    )
)`
    border: 1px solid #0003;
    border-radius: 2px;
    flex: none;
    width: 24px;
`;
